import { StateService } from './../state/stateService';
import { Subject, Subscription } from 'rxjs';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { User } from '../user/user';
import { Client } from '../client/client';
import { Location } from '../location/location';
import { Machine, MachineCreate } from '../machine/machine';
import { Machinetype } from '../machinetype/machinetype';
import { Module } from '../module/module';
import { ModuleService } from '../module/moduleService';
import { MachineService } from '../machine/machineService';
import { LocationService } from '../location/locationService';
import { Router } from '@angular/router';
import { ClientService } from '../client/clientservice';
import { Authenticate } from '../authenticate/authenticate';
import { State } from '../state/state';
import * as XLSX from 'xlsx'

@Component({
  selector: 'app-machinecreate',
  templateUrl: './machinecreate.component.html',
  styleUrls: ['./machinecreate.component.css', '../app.component.less']
})
export class MachinecreateComponent implements OnInit {

  //#region Variables 
  @Input() _currentuser: User;
  @Input() _client: Client;
  _states: State[];
  _clients: Client[];
  _location: Location = new Location;
  _machine: MachineCreate = new MachineCreate;
  _machinetypes: Machinetype[];
  _modules: Module[];
  _tid: number;
  _cid: number;
  _sid: number;
  _selectedmodules: number[];
  redirecturl: string;
  auth: Authenticate;
  arrayBuffer: String | ArrayBuffer;
  file: any;
  uploadEvent: any;
  exceljsondata: unknown[];
  data: any;
  header: any;
  spinnerEnabled = false;
  keys: string[];
  dataSheet = new Subject();
  @ViewChild('inputFile') inputFile: ElementRef;
  isExcelFile: boolean;

  //#endregion

  constructor(
    private moduleservice: ModuleService,
    private machineservice: MachineService,
    private locationservice: LocationService,
    private router: Router,
    private clientservice: ClientService,
    private StateService: StateService

  ) { }

  //-----------------------------------------------------------------------------------
  // PAGE LOAD FUNCTION
  //-----------------------------------------------------------------------------------
  ngOnInit(): void {
    this.moduleservice.getModules().subscribe(resp => { this._modules = resp; console.log(resp); });
    this.machineservice.getTypes().subscribe(resp => { this._machinetypes = resp });
    this.clientservice.getClients().subscribe(resp => { this._clients = resp });
    this.StateService.getStates().subscribe(resp => {
      this._states = resp;
      console.log(this._states);
    });
  }

  //-----------------------------------------------------------------------------------
  // CREATE SINGLE MACHINE
  //-----------------------------------------------------------------------------------
  createMachine_Original() {
 console.log(this._cid);
     this._machine.client =  this._cid; 
    try {
     
      if (
        this._machine.client == null ||
        this._machine.shortname == null ||
        this._machine.serialnumber == null ||
        this._machine.state == null ||
        this._machine.machinetype == null ||
        this._location.addr1 == null ||
        this._location.addr2 == null ||
        this._location.City == null ||
        this._location.Country == null ||
        this._location.contact_name == null ||
        this._location.email == null) {
        window.alert("Data incomplete, please make sure you filled all the information correctly and try again.");
      }
      else {
        this.locationservice.createLocation(this._location).subscribe(resp => {
          this._machine.location = resp.id;
          this._machine.machinetype = this._tid;
          this._machine.modules = this._selectedmodules;
          this._machine.client = this._cid;
          this._machine.state = this._sid;
          this.machineservice.createMachine(this._machine).subscribe(resp => {
            console.log(resp);
            this.redirecturl = "/machines/" + resp.id;
            this.router.navigateByUrl(this.redirecturl);

          });
        });
      }
    }
    catch { }
  }

private isEmpty(v: any): boolean {
  return v === null || v === undefined || (typeof v === 'string' && v.trim() === '');
}
createMachine() {
  try {

    this._machine.state = this._sid;
    this._machine.machinetype = this._tid;
    this._machine.client = this._cid;
    

    const required: Array<[string, any]> = [
      ['Machine: client',        this._machine?.client],
      ['Machine: shortname',     this._machine?.shortname],
      ['Machine: serialnumber',  this._machine?.serialnumber],
      ['Machine: state',         this._machine?.state],
      ['Machine: machinetype',   this._machine?.machinetype],
      ['Location: addr1',        this._location?.addr1],
      ['Location: addr2',        this._location?.addr2],
      ['Location: City',         this._location?.City],
      ['Location: Country',      this._location?.Country],
      ['Location: contact_name', this._location?.contact_name],
      ['Location: email',        this._location?.email],
    ];

    const missing = required
      .filter(([, value]) => this.isEmpty(value))
      .map(([label]) => label);

    if (missing.length > 0) {
      console.error('Missing required fields:', missing);
      window.alert(
        'Data incomplete. Please fill:\n- ' + missing.join('\n- ')
      );
      return; // stop here
    }

    // proceed as before
    this.locationservice.createLocation(this._location).subscribe(resp => {
      this._machine.location = resp.id;
      this._machine.machinetype = this._tid;
      this._machine.modules = this._selectedmodules;
      this._machine.client = this._cid;
      this._machine.state = this._sid;

      this.machineservice.createMachine(this._machine).subscribe(resp => {
        console.log(resp);
        this.redirecturl = '/machines/' + resp.id;
        this.router.navigateByUrl(this.redirecturl);
      });
    });
  } catch (e) {
    console.error('createMachine error:', e);
  }
}


  //-----------------------------------------------------------------------------------
  // EXCEL FILE LOAD FUNCTION
  //-----------------------------------------------------------------------------------
  onChange(evt) {
    try {
      const target: DataTransfer = <DataTransfer>(evt.target);
      this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
      if (target.files.length > 1) {
        this.inputFile.nativeElement.value = '';
      }
      if (this.isExcelFile) {
        this.spinnerEnabled = true;
        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
          /* read workbook */
          const bstr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

          /* grab first sheet */
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];

          /* save data */
          this.data = XLSX.utils.sheet_to_json(ws);

        };

        reader.readAsBinaryString(target.files[0]);

        reader.onloadend = (e) => {
          this.spinnerEnabled = false;
          this.keys = Object.keys(this.data[0]);
          this.dataSheet.next(this.data)
        }

      } else {
        this.inputFile.nativeElement.value = '';
      }
    }
    catch { }
  }


  //-----------------------------------------------------------------------------------
  // CLEAR IMPORTED ROWS
  //-----------------------------------------------------------------------------------
  removeData() {
    try {
      this.inputFile.nativeElement.value = '';
      this.dataSheet.next(null);
      this.keys = null;
    } catch { }
  }
//-----------------------------------------------------------------------------------
// CREATE MACHINES IN BULK (Send array in one request)
//-----------------------------------------------------------------------------------
async createBulk() {
  try {
    // Prepare the array of machines
    const machines: MachineCreate[] = this.data.map((machineData: any) => {
      const machine = new MachineCreate();
      machine.serialnumber = machineData.serialnumber;
      machine.client = machineData.client;
      machine.location = machineData.location;
      machine.machinetype = machineData.machinetype;
      machine.shortname = machineData.shortname;
 //     machine.imageurl = machineData.imageurl;
      machine.state = 1;

      return machine;
    });
console.log("The number of machines to add is = " + machines.length);
    // Send the array of machines to the backend
    this.machineservice.createMachinesInBulk(machines).subscribe(

      (response) => {
       
        window.alert("Creation Successful");
        console.log('Bulk creation successful:', response);
        this.removeData();
      },
      (error) => {
        window.alert("Error Creating Devices! Please double check the file or contact and administrator.");
        console.error('Bulk creation failed:', error);
      }
    );
  } catch (error) { 
    window.alert("Warning and error has occured. Validate file structure and try again.")
    console.error('Error preparing bulk data:', error);
  }
}

}
